import {User} from './User';

export class TreasuryLog {
  id: number;
  closingTimeStamp: Date;
  closingUser: User;
  openingTimeStamp: Date;
  openingUser: User;
  ordinalNumber: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.closingTimeStamp = data.closingTimeStamp ? new Date(data.closingTimeStamp) : null;
      this.openingTimeStamp = data.openingTimeStamp ? new Date(data.openingTimeStamp) : null;
    }
  }
}

export class TreasuryLogFlat {
  id: number;
  closingTimeStamp: string;
  closingUser: string;
  openingTimeStamp: string;
  openingUser: string;
  ordinalNumber: number;

  constructor(data?: TreasuryLog) {
    if (data) {
      this.id = data.id;
      this.closingTimeStamp = data.closingTimeStamp ? data.closingTimeStamp.toLocaleDateString('hr-HR') : '-';
      this.closingUser = data.closingUser ? (data.closingUser.firstName + ' ' + data.closingUser.lastName) : '-';
      this.openingTimeStamp = data.openingTimeStamp ? data.openingTimeStamp.toLocaleDateString('hr-HR') : '-';
      this.openingUser = data.openingUser ? (data.openingUser.firstName + ' ' + data.openingUser.lastName) : '-';
      this.ordinalNumber = data.ordinalNumber;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/TreasuryLog.ts